module.exports = __webpack_public_path__ + "images/artist_500.1d3ee4c04f474086798db8fbe13d4e07.png";